module.exports = __webpack_public_path__ + "img/dariaPushkova.a30040f8.jpg";